import { styled } from "@mui/material/styles";
import { IconButton, Typography } from "@mui/material";

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  fontSize: "0.8rem",
  color: theme.palette.text.primary,
}));

export const Title = styled(Typography)({
  fontWeight: "500",
  margin: "10px 0px",
});
